import type { AppLocale } from './messages';
import { DEFAULT_LOCALE, MESSAGES, type MessageKey } from './messages';

let currentLocale: AppLocale = DEFAULT_LOCALE;

export function setI18nRuntimeLocale(locale: AppLocale): void {
  currentLocale = locale;
}

export function getI18nRuntimeLocale(): AppLocale {
  return currentLocale;
}

/** For use outside React (API module, listeners). */
export function tr(key: MessageKey): string {
  return MESSAGES[currentLocale][key];
}
